import Vue from "vue";
import Vuex from "vuex";

import CreatorAPI from "../../account/apis/CreatorAPI";
import ProfileAPI from "../../account/apis/ProfileAPI";
import Alert from "../classes/Alert";
import Creator from "../../account/classes/Creator";
import ErrorToDisplay from "../classes/ErrorToDisplay";
import AccountService from "../../account/services/AccountService";
/* Modules */
import * as account from "../../account/store/account";
import * as core from "./core";
import * as creator from "../../creator/store/index";
import * as organization from "../../organization/store/index";
import * as navigation from "../../core/store/navigation";
import * as share from "../../share/store/share";
import * as search from "../../search/store/search";


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    core,
    creator,
    organization,
    navigation,
    share,
    search
  },
  state: {
    alert: null,
    myProfileView: {
      postsLoading: false,
      profileLoading: false,
      posts: [],
      creator: new Creator()
    },
    loading: false,
    dialogDisplay: {
      share: false,
      persistent: false,
      managePost: false,
      editing: false,
      managePostPostCreation: false
    },
    shareStateKey: 0
  },

  mutations: {
    INCREMENT_SHARE_STATE_KEY(state) {
      state.shareStateKey++;
    },
    loading(state, loading) {
      state.loading = loading;
    },
    displayError(state, error) {
      state.error.display = error.display;
      state.error.description = error.description;
    },
    mutateCreator(state, creator) {
      state.myProfileView.creator = new Creator(creator);
    },
    SET_CREATOR(state, creator) {
      state.myProfileView.creator = new Creator(creator);
    },
    mutatePostsProfileLoading(state, boolean) {
      state.myProfileView.postsLoading = boolean;
    },
    mutateMyProfilePosts(state, posts) {
      state.myProfileView.posts = [];
      state.myProfileView.posts = posts;
    },
    mutateAlert(state, alertName) {
      state.alert = new Alert(alertName);
    },
    mutateCurrentPopUp(state, popUp) {
      state.currentPopUp.currentApiId = popUp.currentApiId;
      state.currentPopUp.newApiId = popUp.newApiId;
      state.currentPopUp.postId = popUp.postId;
      state.currentPopUp.feature = popUp.feature;
    },
    mutateUserInformationCreator(state, data) {
      state.myProfileView.creator.setUserData(data);
    }
  },
  actions: {
    getCreatorInformations({ commit }) {
      return new Promise((resolve, reject) => {
        CreatorAPI.getMyCreatorProfileAPI().then(response => {
          commit("mutateCreator", response.data);
          resolve(response.data);
        });
      });
    },
    editCreatorInformations({ commit }, creator) {
      commit("loading", true);
      return new Promise((resolve, reject) => {
        ProfileAPI.editUserAPI(creator.getUserDataForEditAPI())
          .then(response => {
            commit("mutateUserInformationCreator", response.data);
            AccountService.editCreator(creator.getCreatorDataForEditAPI())
              .then(response => {
                commit("mutateCreator", response.data);
                commit("loading", false);
                resolve();
              })
              .catch(error => {
                const alert = new ErrorToDisplay(error.response);
                commit("loading", false);
                reject(alert);
              });
          })
          .catch(error => {
            const alert = new ErrorToDisplay(error.response);
            commit("loading", false);
            reject(alert);
          });
      });
    },
    editProfilePicture({ commit, state }, picture) {
      return new Promise((resolve, reject) => {
        CreatorAPI.postProfilePictureAPI(picture)
          .then(pictureReponse => {
            let creator = state.myProfileView.creator.getCreatorDataForEditAPI();
            creator.profilePicture = pictureReponse.data;
            AccountService.editCreator(creator)
              .then(response => {
                commit("mutateCreator", response.data);
                commit("mutateAlert", "pictureProfileUpdated");
                resolve(response.data);
              })
              .catch(err => console.log(err));
          })
          .catch(() => {
            reject();
          });
      });
    }
  },
  getters: {
    isDialogLogin: state => state.dialogDisplay.login,
    isDialogSignUp: state => state.dialogDisplay.signUp,
    isDialogShare: state => state.dialogDisplay.share,
    isPersistent: state => state.dialogDisplay.persistent,
    isManagePostPostCreation: state =>
      state.dialogDisplay.managePostPostCreation,
    isLoading: state => state.loading,
    isLoadingProfile: state => state.myProfileView.profileLoading,
    creator: state => state.myProfileView.creator,
    isWebsiteCreator: state => {
      return !!state.myProfileView.creator.websites.length;
    },
    isYoutubeCreator: state => {
      return !!state.myProfileView.creator.youtubeChannels.length;
    },
    myProfilePosts: state => state.myProfileView.posts,
    myProfileLayers: state => state.myProfileView.layers,
    isLoadingMyProfilePosts: state => state.myProfileView.postsLoading,
    isAlert: state => state.alert.display,
    alert: state => state.alert,
    isDialogProfile: state => state.dialogDisplay.profile
  }
});
